import React from 'react'
import PropTypes from 'prop-types'
import StatisticsContent from './StatisticsContent'

const Statistics = props => <StatisticsContent {...props} />

Statistics.propTypes = {
  collectId: PropTypes.number.isRequired,
  dateRangeMax: PropTypes.string,
  dateRangeMin: PropTypes.string,
  draftId: PropTypes.number,
  draftsCount: PropTypes.number,
  gradeMax: PropTypes.number,
  hasAdditionalAnswer: PropTypes.bool,
  hasAlertsConfigured: PropTypes.bool,
  hasGradeQuestions: PropTypes.bool,
  hasPhotosOrComments: PropTypes.bool,
  recurrent: PropTypes.bool,
  resourcesHref: PropTypes.string.isRequired
}

Statistics.defaultProps = {
  dateRangeMax: null,
  dateRangeMin: null,
  draftId: null,
  draftsCount: null,
  gradeMax: 1,
  hasAdditionalAnswer: false,
  hasAlertsConfigured: false,
  hasGradeQuestions: true,
  hasPhotosOrComments: false,
  recurrent: false
}

export default Statistics
